import { api } from './api'

export const fetchSlot = (query) => api.get('/slot', query)
export const addSlot = (slot) => api.post('/slot', slot)
export const updateSlot = (slot) => api.put(`/slot/${slot.id}`, slot)
export const updateCapacitySlot = (slot) => api.put(`/slot/${slot.id}/capacity`, slot)
export const deleteSlot = (slot) => api.delete(`/slot/${slot.id}`)
